import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/Button';
import LoadingIndicator from '../../components/LoadingIndicator';
import { requestPasswordReset } from '../../services/authService';
import './ForgotPasswordPage.css';

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    try {
      await requestPasswordReset({ email });
      setMessage(
        'パスワードリセット用のリンクを送信しました。メール内のリンクからパスワードをリセットしてください。'
      );
    } catch (err: any) {
      setMessage(err.response?.data?.detail || '送信に失敗しました。');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password-page">
      <h1>パスワードをお忘れの方</h1>
      {loading && <LoadingIndicator isFullPage={false} />}
      {message && <div className="notification success">{message}</div>}
      <form onSubmit={handleSubmit}>
        <label>登録済みのメールアドレス</label>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="example@example.com"
        />
        <Button type="submit" disabled={loading}>
          {loading ? '送信中...' : 'リセットメールを送信'}
        </Button>
      </form>
      <div className="auth-link">
        <p>
          ログインに戻る場合は{' '}
          <span className="link" onClick={() => navigate('/login')}>
            こちら
          </span>
        </p>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
